import { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import MissionBanner from "@/components/MissionBanner";

const NAVY = "#132a63";
const GREEN = "#16a34a";
const YELLOW = "#FFD23F";
const COMISION = 80; // 1 mensualidad por venta

const NICHOS = [
  { icon: "fa-scale-balanced", t: "Legal / Abogacía", d: "Hablas de derechos, trámites, accidentes o asesoría legal." },
  { icon: "fa-truck-pickup", t: "Grúas / Autos / Vial", d: "Contenido de autos, carretera, mecánica o asistencia vial." },
  { icon: "fa-user-doctor", t: "Salud / Atención médica", d: "Divulgación médica, bienestar, primeros auxilios o familia." },
];

const money = (n) => `$${Number(n).toLocaleString("es-MX")}`;

export default function CampanaInfluencers() {
  const [ventas, setVentas] = useState(10);
  const mes = ventas * COMISION;
  const anioConRenov = ventas * COMISION * 12 + ventas * COMISION * 6; // ventas nuevas + renovaciones acumuladas (estimado)

  return (
    <div style={{ fontFamily: "'Poppins',system-ui,sans-serif", color: "white", background: NAVY }}>
      <Helmet><title>Sé Embajador — Gana dinero con Mi Ángel Asís</title></Helmet>

      {/* HERO */}
      <section style={{ padding: "56px 20px 40px", textAlign: "center", background: `radial-gradient(circle at 50% 0%, #1c3a80, ${NAVY})` }}>
        <div style={{ maxWidth: 760, margin: "0 auto" }}>
          <span style={{ background: GREEN, color: "white", fontWeight: 800, fontSize: 12, padding: "6px 14px", borderRadius: 999, letterSpacing: 1 }}>PROGRAMA DE EMBAJADORES</span>
          <h1 style={{ fontSize: 40, fontWeight: 900, lineHeight: 1.1, margin: "18px 0 12px" }}>
            Gana dinero <span style={{ color: YELLOW }}>protegiendo familias</span>
          </h1>
          <p style={{ fontSize: 17, opacity: 0.9, maxWidth: 560, margin: "0 auto 26px" }}>
            Recomienda Mi Ángel Asís a tu comunidad y recibe <strong style={{ color: GREEN }}>una mensualidad por cada venta</strong> — y otra <strong>cada vez que renuevan</strong>. Sin límites.
          </p>
          <Link to="/socios/registro" data-testid="campana-cta-hero"
            style={{ display: "inline-block", background: YELLOW, color: NAVY, textDecoration: "none", padding: "16px 38px", borderRadius: 999, fontSize: 17, fontWeight: 900, boxShadow: "0 10px 30px rgba(255,210,63,0.35)" }}>
            Quiero ser Embajador →
          </Link>
        </div>
      </section>

      {/* MISIÓN */}
      <section style={{ background: NAVY, padding: "8px 20px 32px" }}>
        <div style={{ maxWidth: 760, margin: "0 auto" }}>
          <MissionBanner variant="dark" />
        </div>
      </section>

      {/* NICHOS */}
      <section style={{ background: "white", color: NAVY, padding: "48px 20px" }}>
        <div style={{ maxWidth: 960, margin: "0 auto", textAlign: "center" }}>
          <h2 style={{ fontSize: 26, fontWeight: 800, marginBottom: 6 }}>Buscamos creadores como tú</h2>
          <p style={{ color: "#6b7280", marginBottom: 30 }}>Especialmente si tienes <strong>+25,000 seguidores</strong> y hablas de:</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(230px,1fr))", gap: 18 }}>
            {NICHOS.map((n, i) => (
              <div key={i} style={{ background: "#F3F7FF", borderRadius: 18, padding: 26, textAlign: "left" }} data-testid={`campana-nicho-${i}`}>
                <div style={{ width: 52, height: 52, borderRadius: 14, background: GREEN, color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, marginBottom: 14 }}>
                  <i className={`fas ${n.icon}`} />
                </div>
                <div style={{ fontSize: 18, fontWeight: 800 }}>{n.t}</div>
                <p style={{ color: "#6b7280", fontSize: 14, marginTop: 6 }}>{n.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CALCULADORA */}
      <section style={{ background: NAVY, padding: "48px 20px" }}>
        <div style={{ maxWidth: 620, margin: "0 auto", background: "white", color: NAVY, borderRadius: 22, padding: "32px 28px", textAlign: "center", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: GREEN, letterSpacing: 1 }}>CALCULADORA DE GANANCIAS</div>
          <h2 style={{ fontSize: 24, fontWeight: 800, margin: "8px 0 20px" }}>¿Cuánto puedes ganar?</h2>
          <label style={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>Ventas que consigues al mes: <strong style={{ color: NAVY, fontSize: 18 }}>{ventas}</strong></label>
          <input type="range" min="1" max="50" value={ventas} onChange={(e) => setVentas(Number(e.target.value))} data-testid="campana-slider"
            style={{ width: "100%", margin: "14px 0 22px", accentColor: GREEN }} />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <div style={{ background: "#EAF6ED", borderRadius: 14, padding: 18 }}>
              <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 600 }}>Este mes</div>
              <div style={{ fontSize: 28, fontWeight: 900, color: GREEN }} data-testid="campana-ganancia-mes">{money(mes)}</div>
            </div>
            <div style={{ background: "#F3F7FF", borderRadius: 14, padding: 18 }}>
              <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 600 }}>En 12 meses (con renovaciones)*</div>
              <div style={{ fontSize: 28, fontWeight: 900, color: NAVY }} data-testid="campana-ganancia-anio">{money(anioConRenov)}</div>
            </div>
          </div>
          <p style={{ fontSize: 11, color: "#9ca3af", marginTop: 14 }}>*Estimado: {money(COMISION)} por venta + una mensualidad extra por cada renovación. Tus ganancias reales dependen de tus ventas.</p>
          <Link to="/socios/registro" data-testid="campana-cta-calc"
            style={{ display: "inline-block", marginTop: 20, background: GREEN, color: "white", textDecoration: "none", padding: "14px 34px", borderRadius: 999, fontWeight: 800 }}>
            Empezar a ganar →
          </Link>
        </div>
      </section>

      {/* CÓMO FUNCIONA */}
      <section style={{ background: "white", color: NAVY, padding: "48px 20px" }}>
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 34 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: GREEN, letterSpacing: 1 }}>ASÍ DE FÁCIL</div>
            <h2 style={{ fontSize: 26, fontWeight: 800, margin: "6px 0 0" }}>Cómo funciona en 3 pasos</h2>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: 22 }}>
            {[
              { n: "1", t: "Regístrate gratis", d: "En 2 minutos creas tu cuenta de Embajador. Sin costo, sin permanencia." },
              { n: "2", t: "Comparte tu link único", d: "Recibes un link personalizado + kit de marketing (imágenes, videos, textos listos)." },
              { n: "3", t: "Cobras cada mes", d: "Ganas comisión por cada venta y otra por cada renovación. Depósito directo a tu cuenta." },
            ].map((s, i) => (
              <div key={i} data-testid={`campana-paso-${i}`}
                style={{ background: "#F3F7FF", borderRadius: 18, padding: 24, position: "relative" }}>
                <div style={{ position: "absolute", top: -18, left: 20, width: 44, height: 44, borderRadius: "50%", background: YELLOW, color: NAVY, fontSize: 22, fontWeight: 900, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 4px 12px rgba(0,0,0,0.15)" }}>{s.n}</div>
                <div style={{ fontSize: 17, fontWeight: 800, marginTop: 20 }}>{s.t}</div>
                <p style={{ color: "#4b5563", fontSize: 14, marginTop: 8, lineHeight: 1.5 }}>{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* POR QUÉ NOSOTROS */}
      <section style={{ background: "#F9FAFB", color: NAVY, padding: "48px 20px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 30 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: GREEN, letterSpacing: 1 }}>DIFERENCIA REAL</div>
            <h2 style={{ fontSize: 26, fontWeight: 800, margin: "6px 0 0" }}>¿Por qué Mi Ángel Asís vs. otros programas?</h2>
          </div>
          <div style={{ background: "white", borderRadius: 20, overflow: "hidden", boxShadow: "0 6px 24px rgba(0,0,0,0.06)" }}>
            {[
              { l: "Comisión por primera venta", n: "1 mensualidad completa", o: "10–30% típicamente" },
              { l: "Comisión por renovaciones", n: "Sí, cada mes que renueva", o: "Rara vez" },
              { l: "Kit de marketing", n: "Incluido (imágenes + videos + copys)", o: "Tú lo armas" },
              { l: "Pago mínimo", n: "Sin mínimo — cobras cuando quieras", o: "Pagos altos ($500+ USD)" },
              { l: "Producto real que ayuda", n: "Grúa, ambulancia, legal, salud", o: "Cursos / infoproductos" },
            ].map((row, i) => (
              <div key={i} style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr 1fr", padding: "14px 20px", borderTop: i > 0 ? "1px solid #F3F4F6" : "none", fontSize: 14 }}>
                <div style={{ fontWeight: 700 }}>{row.l}</div>
                <div style={{ color: GREEN, fontWeight: 700 }}><i className="fas fa-check-circle" style={{ marginRight: 6 }} />{row.n}</div>
                <div style={{ color: "#9ca3af" }}>{row.o}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section style={{ background: "white", color: NAVY, padding: "48px 20px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 26 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: GREEN, letterSpacing: 1 }}>DUDAS COMUNES</div>
            <h2 style={{ fontSize: 26, fontWeight: 800, margin: "6px 0 0" }}>Preguntas frecuentes</h2>
          </div>
          {[
            { q: "¿Cuánto tarda el pago después de una venta?", a: "Depositamos cada mes los días 5, después de confirmar que la venta no fue reembolsada en los primeros 15 días. Depósito SPEI a tu CLABE o transferencia bancaria." },
            { q: "¿Necesito facturar?", a: "Si superas $30,000 MXN al año en comisiones te pediremos RFC y CFDI para deducibilidad. Debajo de eso, opera como ingreso extra sin más trámite." },
            { q: "¿Puedo usar mi propio código de descuento?", a: "Sí. Al registrarte eliges tu código personalizado (ej. ANGEL-JUAN) y tus seguidores obtienen un descuento especial al usarlo." },
            { q: "¿Cuántos seguidores necesito?", a: "Aceptamos creadores desde 5,000 seguidores en cualquier red (TikTok, Instagram, YouTube, Facebook). Lo que importa es que tu audiencia sea real y esté en México." },
            { q: "¿Y si mi venta se cancela o pide reembolso?", a: "Solo pagamos por ventas confirmadas después del periodo de reembolso (15 días). Si el cliente se va antes, esa venta no genera comisión — pero tú no arriesgas nada." },
            { q: "¿Puedo dejar de ser embajador cuando quiera?", a: "Sí, sin permanencia. Puedes pausar o cancelar cuando quieras desde tu panel." },
          ].map((f, i) => (
            <details key={i} data-testid={`campana-faq-${i}`}
              style={{ background: "#F9FAFB", borderRadius: 14, padding: "16px 18px", marginBottom: 10, borderLeft: `3px solid ${GREEN}` }}>
              <summary style={{ cursor: "pointer", fontWeight: 700, fontSize: 15, listStyle: "none", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
                {f.q}
                <i className="fas fa-plus" style={{ color: GREEN, fontSize: 12 }} />
              </summary>
              <div style={{ color: "#4b5563", fontSize: 14, marginTop: 10, lineHeight: 1.6 }}>{f.a}</div>
            </details>
          ))}
        </div>
      </section>

      {/* TESTIMONIOS */}
      <section style={{ background: "white", color: NAVY, padding: "48px 20px" }}>
        <div style={{ maxWidth: 760, margin: "0 auto", textAlign: "center" }}>
          <h2 style={{ fontSize: 24, fontWeight: 800, marginBottom: 26 }}>Socios que ya están ganando</h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: 18 }}>
            {[
              { img: "/socios/socio_hombre.png", cap: "«Gracias Ángel, ya tengo la universidad de mi hijo.»" },
              { img: "/socios/socia_mujer.png", cap: "«Gracias Ángel, ya puedo empezar mi negocio.»" },
            ].map((t, i) => (
              <div key={i} style={{ borderRadius: 18, overflow: "hidden", boxShadow: "0 4px 18px rgba(0,0,0,0.12)" }}>
                <img src={t.img} alt="Socio feliz" style={{ width: "100%", height: 230, objectFit: "cover", display: "block" }} />
                <div style={{ padding: 14, fontWeight: 700, fontStyle: "italic", fontSize: 14 }}>{t.cap}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CIERRE */}
      <section style={{ background: GREEN, padding: "44px 20px", textAlign: "center" }}>
        <h2 style={{ fontSize: 26, fontWeight: 900, color: NAVY, margin: "0 0 14px" }}>Únete gratis y en 2 minutos</h2>
        <Link to="/socios/registro" data-testid="campana-cta-final"
          style={{ display: "inline-block", background: NAVY, color: "white", textDecoration: "none", padding: "16px 40px", borderRadius: 999, fontSize: 17, fontWeight: 900 }}>
          Crear mi cuenta de Embajador →
        </Link>
        <div style={{ marginTop: 14 }}>
          <Link to="/socios/login" style={{ color: NAVY, fontWeight: 700, fontSize: 14 }}>¿Ya eres socio? Inicia sesión</Link>
        </div>
      </section>
    </div>
  );
}
